import { Injectable } from '@angular/core';
import { CustomFields } from '@vendasta/platform-integrations';
import { AppleLocation } from './auto-complete.component';

@Injectable({
  providedIn: 'root', // Makes it available globally
})
// We want to display the location name + business name as the "location". This isn't how we store the
// fields in the backend, there is no "location" only location name and business name.
export class AppleAutoCompleteService {
  getLocationName(businessName: string, locationName: string): string {
    if (businessName) {
      return `${businessName} > ${locationName}`;
    }
    if (!locationName) {
      return '';
    }
    return locationName;
  }

  // Gets the location name from the connection custom fields.
  // This function will take the custom fields, figure out the current location label and return it.
  getLocationNameFromCustomFields(customFields: CustomFields[]): string {
    return customFields.find((field) => field.label === 'locationName')?.value || '';
  }

  getLocationFromCustomFields(customFields: CustomFields[]): AppleLocation | undefined {
    const lid = customFields.find((field) => field.label === 'locationId')?.value || '';
    const locName = customFields.find((field) => field.label === 'locationName')?.value || '';
    const state = customFields.find((field) => field.label === 'state')?.value || '';
    const partnersLocationId = customFields.find((field) => field.label === 'partnersLocationId')?.value || '';
    const partnersLocationVersion =
      customFields.find((field) => field.label === 'partnersLocationVersion')?.value || '';
    if (!lid || !locName || !state || !partnersLocationId) {
      return;
    }

    return {
      locationId: lid,
      // Brands are still labelled as businesses in custom fields
      brandId: customFields.find((field) => field.label === 'businessId')?.value || '',
      name: locName,
      state: state,
      placeCardUrl: customFields.find((field) => field.label === 'placeCardUrl')?.value || '',
      partnersLocationId: partnersLocationId,
      partnersLocationVersion: partnersLocationVersion,
    };
  }

  findLocation(customFields: CustomFields[], locations: AppleLocation[]): AppleLocation | undefined {
    const lid = customFields.find((field) => field.label === 'locationId')?.value || '';
    if (!lid) {
      return;
    }
    const bid = customFields.find((field) => field.label === 'businessId')?.value || '';

    return locations.find((field) => {
      return field.locationId === lid && field.brandId === bid;
    });
  }
}
